import SEO from './SEO';

const BASE = "https://www.keystoneinsurance.ca";

const pages = {
  home: {
    title: "Keystone Insurance Brokers | Surrey, BC | Auto, Home & Business Insurance",
    description: "Independent, licensed insurance brokers serving Surrey and Greater Vancouver for over 20 years. Auto, home, business, life, and travel insurance. Call (604) 595-8666.",
    canonical: `${BASE}/`,
  },
  about: {
    title: "About Us | Keystone Insurance Brokers Surrey, BC",
    description: "Learn about Keystone Insurance Brokers Ltd — Surrey's trusted independent insurance brokerage with over 20 years of experience serving Greater Vancouver.",
    canonical: `${BASE}/about`,
  },
  services: {
    title: "Insurance Services | Auto, Home, Business & Travel | Keystone Insurance Surrey",
    description: "Keystone Insurance Brokers offers auto, home, business, life, travel, liability, and commercial property insurance in Surrey, BC. Get a free quote today.",
    canonical: `${BASE}/services`,
  },
  contact: {
    title: "Contact Keystone Insurance Brokers | Surrey, BC | (604) 595-8666",
    description: "Contact Keystone Insurance Brokers Ltd at 103-8077 King George Blvd, Surrey, BC. Call (604) 595-8666 or email Keystoneins@shaw.ca for a free, no-obligation quote.",
    canonical: `${BASE}/contact`,
  },
  privacy: {
    title: "Privacy Policy | Keystone Insurance Brokers Ltd",
    description: "Read the privacy policy for Keystone Insurance Brokers Ltd, Surrey, BC.",
    canonical: `${BASE}/privacy`,
  },
  terms: {
    title: "Terms of Service | Keystone Insurance Brokers Ltd",
    description: "Read the terms of service for Keystone Insurance Brokers Ltd, Surrey, BC.",
    canonical: `${BASE}/terms`,
  },
};

export default function PageSEO({ page }) {
  const seo = pages[page];
  if (!seo) return null;
  return <SEO title={seo.title} description={seo.description} canonical={seo.canonical} />;
}